<script>
import moment from 'moment';

export default {
    components: {
    },

    metaInfo: {
        title: 'My Rewards',
    },


    filters: {
        postedTime(createdDate) {
            return moment(createdDate).fromNow();
        },
    },


    data() {
        return {
            hasMore: true,
            postedDeals: [],
            isLoading: false,
            availableBalance: 0,
            tracked: 0,
            page: 1,
            totalEarned: 0,
            rewardsData: {
                available_funds: 0,
                tracked_funds: 0,
                paid_funds: 0,
            },
        };
    },



    async mounted() {
        this.isLoading = true;

        const postedDeals = await window.axios.get('/api/user/earnings', {params: {page: this.page}});
        this.postedDeals = postedDeals.data;

        const rewardsData = await window.axios.get('/api/user/rewards');
        this.rewardsData = rewardsData.data;

        this.isLoading = false;
    },

    methods: {
        async loadMoreEarnings() {
            this.isLoading = true;
            this.page = this.page + 1;

            const postedDeals = await window.axios.get('/api/user/earnings', {params: {page: this.page}});
            this.postedDeals = this.postedDeals.concat(postedDeals.data);

            if(postedDeals.data.length == 0) {
                this.hasMore = false;
            }

            this.isLoading = false;
        },

        generateDealURI(deal) {
            const title = deal.title.replace(/[^a-z0-9_]+/gi, '-').replace(/^-|-$/g, '').toLowerCase();
            return title;
        },
    },
};
</script>

<template lang='pug' src='./template/Rewards.pug'></template>
<style lang='stylus' src='./styles/Rewards.styl' scoped></style>

